















import Vue from 'vue'
import AppHeader from './components/AppHeader.vue'
export default Vue.extend({
  name: 'app',
  props: {
    source: String,
  },
  components: {
    AppHeader
  },
  watch: {
    $route (to, from) {
      document.title = to.name + ' / Suzuka Hisamatsu - between us -'
    },
  }
})
